module.exports = __webpack_public_path__ + "img/home_2.79b8ee18.png";